import React from "react";
import CardSimple from "../../../../../components/basic/CardSimple";

const WebMenu = () => {
  return (
    <div id="web-menu-desc">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Web-Menu Description</h2>
            <p>
              The Web Menu Feature makes use of the product data you enter into
              your system and displays it for customers to browse and reserve on
              the web.
            </p>
            <p>
              This Feature consists of two main pages. The Home Page contains a
              Carousel that will periodically rotate the Products it highlights,
              as well as up to 3 other Product Groups. The second one is the
              Menu Page, which will display all other Product Groups you want it
              to.
            </p>
          </div>
        </CardSimple>
      </div>
      <div id="web-menu-create-group">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>How to Create Product Groups to display on the Web Menu</h2>
            <ul>
              <li>First go to Web Menu  Menu</li>
              <li>
                Here you can create and see all existing Product Groups. An item
                Group can represent an existing category in your store or a new
                one, such as “Featured” or “Sales”
              </li>
              <li>To create a Group, click the "New Menu Group” button</li>
              <li>
                The Name and Description will appear at the top of the Web Menu
                when a user enters the Group in the Menu
              </li>
              <li>
                The Status switch determines if the Group will be visible on the
                Web Menu
              </li>
              <li>
                The “Display on Menu Page?” switch determines if the Group will
                appear on the Menu Page. If turned off, the Product Group will
                be available on the Home Page.
              </li>
              <li>
                And finally you will add Products to the Group with the “Add
                Items To Menu” button
              </li>
              <li>Hit Save and wait for Success Message</li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="web-menu-finalize">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>How to Finalize the look of the Web Menu</h2>
            <ul>
              <li>
                Once you have created all the desired groups, move to Web Menu 
                Home Setting
              </li>
              <li>
                First select a Product Group to place on the Carousel. This
                group should consist of 3 - 6 items you wish to highlight to
                your consumers
              </li>
              <li>
                Next you choose the order of all Product Groups that have been
                turned off in the “Display on Menu Page?" These groups will
                appear below the Carousel on the Home Page.
              </li>
              <li>
                All other Product Groups you created with "Status" set to ON and
                "Display on Menu Page?" set to ON will appear on the Menu Page
              </li>
            </ul>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default WebMenu;
